import { useState } from "react";

export function useDialog<T extends string = string>() {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogType, setDialogType] = useState<T | null>(null);

  const openDialog = (type: T) => {
    setIsOpen(true);
    setDialogType(type);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setDialogType(null);
  };

  return { isOpen, dialogType, openDialog, closeDialog };
}
